<mat-toolbar color="primary" class="toolbar">
  
  <!-- LEFT SIDE ------------------------------>
  <!-- BURGER MENU -->
  <div class="toolbar-spacer mobile" *ngIf="showSpacer()"></div>
  <div class="toolbar-spacer desktop" *ngIf="showSpacer()"></div>
  <button mat-icon-button *ngIf="isButtonVisible('burger')" [matMenuTriggerFor]="menu">
    <mat-icon>menu</mat-icon>
  </button>  
  
  <div class="flex-row" *ngIf="isButtonVisible('back') || isButtonVisible('videocall') || isButtonVisible('home')">

    <!-- <button mat-icon-button (click)="toggleLanguage()" class="button button-header mobile" *ngIf="getCurrentLanguage() == 'en'">
      <span><mat-icon>🇪🇸</mat-icon></span>
      <span>ES</span>
    </button>

    <button mat-icon-button (click)="toggleLanguage()" class="button button-header mobile" *ngIf="getCurrentLanguage() == 'es'">
      <span><mat-icon>🇬🇧</mat-icon></span>
      <span>EN</span>
    </button> -->

    <!-- GO HOME -->
    <button mat-icon-button *ngIf="isButtonVisible('home')" class="button button-header desktop" (click)="goToPage('home')"><mat-icon>home</mat-icon></button>
    <button mat-icon-button *ngIf="isButtonVisible('home')" class="button button-header mobile" (click)="goToPage('home')"><mat-icon>home</mat-icon></button>

    <!-- GO BACK -->
    <div class="burger-cnt back-button" (click)="goBack()" *ngIf="isButtonVisible('back')">
      <i class="fas fa-angle-left back-btn"></i>
    </div>

    <!-- VIDEOCALL --> <!-- matBadge="gratis" matBadgeColor="warn" isVideocallPromoActive() -->
    <button mat-stroked-button *ngIf="isButtonVisible('videocall')" class="button button-header desktop" (click)="goToVideoCallCard()">Reservar Videollamada</button>
    <button mat-icon-button *ngIf="isButtonVisible('videocall')" class="button button-header mobile" (click)="goToVideoCallCard()"><mat-icon>call</mat-icon></button>
  </div>
  
  <!-- CENTER ------------------------------>
  <!-- LOGO -->
  <div class="toolbar-title" (click)="goToPage('home')">
    <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/71ceeedb-5297-4289-b246-87e594f0ff00/public" class="mobile-logo" alt="logo">
    <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/71ceeedb-5297-4289-b246-87e594f0ff00/public" class="desktop-logo" alt="logo">
  </div>

  <!-- RIGHT SIDE ------------------------------>
  <div>

    <!-- LOGIN -->
    <button mat-icon-button *ngIf="isButtonVisible('login')"  class="button button-header mobile" (click)="goToPage('login')"><mat-icon>account_circle</mat-icon></button>
    <button mat-icon-button *ngIf="isButtonVisible('login')"  class="button button-header desktop" (click)="goToPage('login')">{{'AUTH.LOGIN.TITLE' | translate}}</button>
    <!-- REGISTER -->
    <button mat-button *ngIf="isButtonVisible('register')" class="button button-header" (click)="goToPage('register')">{{'AUTH.REGISTER.TITLE' | translate}}</button>

    <!-- USER MENU -->
    <button mat-icon-button [matMenuTriggerFor]="menuUser" *ngIf="isButtonVisible('userMenu')">
      <mat-icon>account_circle</mat-icon>
    </button>

  </div>
  
</mat-toolbar>



<mat-toolbar class="toolbar" *ngIf="false">


    <div class="toolbar-title">
      <div class="responsive-logo">
        <a href="javascript: void(0)" (click)="goToPage('home')">
          <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/e2398d78-f4e9-43b9-77c7-c58737e15f00/public" class="mobile-logo" alt="logo">
        </a>
      </div>
    </div>

    <!-- Logo ============================================= -->
    <!-- <div class="logo-cnt" (click)="goToPage('home')">
      <img *ngIf="showLogoImage != 'false'" [src]="imageUrl" alt="logo" class="header-logo" (click)="goToPage('home')">
      <span *ngIf="showLogoImage === 'false'" class="instagram-logo">{{textLogo}}</span>
    </div> -->
    

    <!-- <app-shopping-cart *ngIf="shoppingCart"></app-shopping-cart> -->

  
    <!-- DOTS -->
    <button mat-icon-button  [matMenuTriggerFor]="menuFreemium" aria-label="Example" *ngIf="visibleDotsMenu">
      <mat-icon class="margin-sides-1rem icon-gray">more_vert</mat-icon>
    </button>

    <!-- DOTS MENU -->
    <mat-menu #menuFreemium="matMenu">
      <button mat-menu-item (click)="goToPage('faqs')">
        <mat-icon>question_answer</mat-icon>
        <span>FAQs</span>
      </button>
      <button mat-menu-item  (click)="openDrive()" ><!--  *ngIf="isAdminLoggedIn()" -->
        <mat-icon><i class="fab fa-google-drive"></i></mat-icon>
        <span>Google Drive</span>
      </button>
      <button mat-menu-item > <!-- *ngIf="isAdminLoggedIn()" -->
        <mat-icon>bug_report</mat-icon>
        <span>Debugger</span>
      </button>
      <button mat-menu-item   (click)="goToPage('client-historic')"> 
        <mat-icon>history</mat-icon>
        <span>Historic</span> 
      </button> <!-- *ngIf="isAdminLoggedIn()" -->
      
    </mat-menu>
  </mat-toolbar>
  
  <!-- BURGER MENU ITEMS -->
  <mat-menu #menu="matMenu">
    <button mat-menu-item *ngFor="let item of getBurgerMenuItems()" (click)="item.route ? goToPage(item.route) : item.action()">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </button>
  </mat-menu>

   <!-- USER MENU ITEMS -->
   <mat-menu #menuUser="matMenu">
    <button mat-menu-item *ngFor="let item of getUserMenuItems()" (click)="item.route ? goToPage(item.route) : item.action()">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </button>
  </mat-menu>